import {Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {UntypedFormBuilder} from '@angular/forms';
import {ModalDirective} from 'ngx-bootstrap/modal';
import {DynamicFormComponent} from '../../dynamic-form/containers/dynamic-form/dynamic-form.component';
import {BaseGridNoCookieComponent} from '../basegrid/basegridnocookie.component';
import {EventsEmitterService} from '../services/emitter.service';
import {LogService} from '../services/log.service';
import {SecurityService} from '../services/security.service';
import {VisualsService} from '../services/visuals.service';
import {BaseSearchModalService} from './basesearchmodal.service';

@Component({
  selector: 'basesearchmodal',
  templateUrl: './basesearchmodal.component.html',
  providers: [BaseSearchModalService],
})
export class BaseSearchModalComponent extends BaseGridNoCookieComponent<BaseSearchModalService> {
  @ViewChild('basesearchmodal') public basesearchmodal: ModalDirective;
  @ViewChild(DynamicFormComponent) public form: DynamicFormComponent;

  /*
   *  Modal handling
   */
  public returnJSON = {};
  @Output() valueChange = new EventEmitter();

  @Input()
  get value() {
    return this.returnJSON;
  }

  set value(val) {
    this.returnJSON = val;
    this.valueChange.emit(this.returnJSON);
  }

  @Input('type')
  set _type(value: string) {
    this.group = value;
    let snm = this.groupToService(value);
    this.serviceName = snm;
    this.gridService.setServiceName(snm);
    this.logger.log(snm);

    this.loadVisuals();
    this.getValidationMessages();
  }

  public showChildModal(): void {
    this.basesearchmodal.show();
  }

  public hideChildModal(): void {
    this.basesearchmodal.hide();
  }

  public passData(data): void {
    this.value = data;
    this.hideChildModal();
  }

  /*
   *  Grid
   */
  constructor(
    public gridService: BaseSearchModalService,
    public eventsEmitterService: EventsEmitterService,
    public securityService: SecurityService,
    logger: LogService,
    public fb: UntypedFormBuilder,
    visualsService: VisualsService,
  ) {
    super(securityService, logger, visualsService, gridService, '');

    //this.loadVisuals();

    this.eventsEmitterService.languageChange.subscribe({
      next: (langId) => {
        this.loadVisuals();
        this.getValidationMessages();
      },
    });
  }

  //Grid Search Form Modal Handler
  handleModalOutput(event: any) {}
}
